// styles
import {
  color,
  COLOR_VARIANTS,
  Divider,
  Tooltip,
  Typography,
  TYPOGRAPHY_VARIANT,
} from "@tajawal/ct-web-design-system";
import Styled from "./Stops.styled";

// hooks
import { useTranslation } from "react-i18next";
import StopsTooltip from "@/app-desktop/components/StopsTooltip";
import { SegmentModel } from "@tajawal/web-flights-sdk/lib/types/segment.types";
import { getStopInfoContent } from "@/utils/content.utils";

export type StopsProps = {
  stopsLength: number;
  hasChangeAirportFlag: boolean;
  onlyDuration?: boolean;
  duration?: string;
  testId: string;
  isSelected?: boolean;
  segmentStops: SegmentModel[];
  resources: any;
};

function Stops({
  stopsLength,
  hasChangeAirportFlag,
  testId,
  onlyDuration = false,
  duration,
  isSelected,
  segmentStops,
  resources,
}: StopsProps): JSX.Element {
  const { t } = useTranslation();

  const segmentStopsContent = getStopInfoContent(segmentStops, resources, t);
  const isDirect = stopsLength === 0;

  let stopsTextColor = isDirect
    ? COLOR_VARIANTS.FORESTPRESSED
    : COLOR_VARIANTS.GREYCHATEAU;
  if (hasChangeAirportFlag) {
    stopsTextColor = COLOR_VARIANTS.CORALPRESSED;
  }

  return (
    <Styled.StopsWrapper $isSelected={isSelected}>
      <Styled.Dot $isSelected={isSelected} />
      <Divider style={{ flexGrow: 1 }} className="divider" variant="solid">
        {stopsLength === 0 || onlyDuration ? (
          <Typography
            testId={testId}
            color={stopsTextColor}
            component="span"
            variant={TYPOGRAPHY_VARIANT.CAPTIONREG}
          >
            {onlyDuration ? duration : t("Common.Direct")}
          </Typography>
        ) : (
          <Tooltip
            title={
              <StopsTooltip
                segmentStops={segmentStopsContent}
                stopsLength={stopsLength}
                testId={testId}
              />
            }
            placement="top"
          >
            <div>
              <Typography
                testId={testId}
                color={stopsTextColor}
                component="span"
                variant={TYPOGRAPHY_VARIANT.CAPTIONREG}
              >
                {t("Common.Stop", {
                  count: stopsLength || 1,
                  stops: stopsLength,
                })}
              </Typography>
            </div>
          </Tooltip>
        )}
      </Divider>
      <Styled.FlightsIcon
        width="16"
        height="16"
        color={
          isSelected
            ? color(COLOR_VARIANTS.AQUA100)
            : color(COLOR_VARIANTS.GAINSBORO)
        }
      />
    </Styled.StopsWrapper>
  );
}

export default Stops;
